import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
    table_cell: ({ maxWidth, minWidth, width, whiteSpace }) => ({
        maxWidth,
        minWidth,
        whiteSpace,
        width,
    }),
}));
//# sourceMappingURL=ui_table_cell.css.js.map